



























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { AdminCMSModule } from '@/app/store/modules/adminCMS'

@Component
export default class extends Vue {
  @Prop({}) public idModal
  @Prop({}) public id
  @Prop({}) public name
  @Prop({}) public email
  @Prop({}) public roleId
  @Prop({}) public password

  public Name: string = ''
  public changeName(e) {
    this.Name = e
  }

  public Email: string = ''
  public changeEmail(e) {
    this.Email = e
  }

  public get listRole() {
    return this.role_id.concat(AdminCMSModule.RoleCMSData)
  }

  public showstatus: string = 'true'
  public iconType: string = 'lock'
  public disable: boolean = true
  public passwordType: string = 'password'
  public Password: string = ''
  public iconTypepassword: string = 'eye-slash'
  public changePassword(e) {
    this.Password = e
  }

  public changeShowStatus() {
    if (this.showstatus === 'true') {
      this.disable = false
      this.showstatus = 'false'
      this.iconType = 'unlock'
    } else {
      this.disable = true
      this.showstatus = 'true'
      this.iconType = 'lock'
    }
  }
  public changePasswordType() {
    if (this.passwordType === 'password') {
      this.passwordType = 'text'
      this.iconTypepassword = 'eye'
    } else {
      this.passwordType = 'password'
      this.iconTypepassword = 'eye-slash'
    }
  }

  public role_id: any = [{ value: 0, text: '-Select Role-' }]

  public get validName(): boolean {
    return this.name.length >= 4 ? true : false
  }

  public get validEmail(): boolean {
    return this.email.length >= 4 ? true : false
  }

  public resetAdd() {
    this.name = ''
    this.Email = ''
    this.roleId = ''
  }

  public async patchNotif(item, index, button) {
    if (this.validName === false || this.validEmail === false) {
      return
    } else {
      const dataToEdit = {
        id: this.id,
        name: this.Name === '' ? this.name : this.Name,
        email: this.Email === '' ? this.email : this.Email,
        password: this.Password,
        role_id: this.roleId,
      }
      AdminCMSModule.updateUser(dataToEdit)
      this.$root.$emit('bv::hide::modal', 'edit-notification', button)
    }
  }
}
